import(/* webpackMode: "eager" */ "/home/runner/work/tuic-nextjs-frontend/tuic-nextjs-frontend/apps/dashboard/src/app/[locale]/error.tsx");
